import { render, staticRenderFns } from "./ListCustomer.vue?vue&type=template&id=07f3ed20&scoped=true&"
import script from "./ListCustomer.vue?vue&type=script&lang=js&"
export * from "./ListCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ListCustomer.vue?vue&type=style&index=0&id=07f3ed20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f3ed20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VCheckbox,VSimpleTable,VTooltip})
